import React, { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import { promptedState } from "../../utils/recoil";
import ChatLoader from "./ChatLoader";

const Chat = ({ id, answers, isLoading }) => {
  const chatRef = useRef(null);

  const [prompted, setPrompted] = useRecoilState(promptedState);

  useEffect(() => {
    chatRef.current.scrollTo({
      top: chatRef.current.scrollHeight,
      behavior: "smooth",
    });
    setPrompted(false);
  }, [prompted, setPrompted, isLoading, answers]);

  return (
    <div
      ref={chatRef}
      className="flex flex-col gap-10 overflow-scroll no-scrollbar h-[75vh] mb-24 max-w-5xl md-max:w-[calc(100vw-1.5rem)] mx-auto"
    >
      {answers &&
        answers.length &&
        answers.map((promptObj, index) => (
          <React.Fragment key={index}>
            <div className="flex flex-col gap-5 items-end mt-4">
              <div className="bg-[#3C82F6] text-white rounded-2xl w-full max-w-max md-max:w-[90%] text-left p-6">
                <p className="text-base">{promptObj.prompt}</p>
              </div>
            </div>
            <div className="flex flex-col gap-5 items-start">
              <div className="bg-white text-[#282F40] rounded-2xl w-full max-w-max md-max:w-[90%] text-left p-6">
                {!promptObj.answer ? (
                  <ChatLoader />
                ) : (
                  <p style={{ whiteSpace: "pre-line" }} className="text-base">
                    {promptObj.answer}
                  </p>
                )}
              </div>
            </div>
          </React.Fragment>
        ))}
      {isLoading && <ChatLoader />}
    </div>
  );
};

export default Chat;
